import Vue from 'vue'

import { globalErrorHandler, globalErrorProcessor, orderDirections, services, states } from '@/utils'

import render from './render'

const apiPath = `/n/${services['otp-handler']}`

export default {
  name: 'Channel',

  props: {
    requestId: {
      type: String,
      default: undefined
    }
  },

  data() {
    return {
      state: states.empty,

      items: []
    }
  },

  computed: {
    hasItems() {
      return Array.isArray(this.items) && this.items.length > 0
    }
  },

  watch: {
    'pagination.offset'() {
      this.getItems()
    }
  },

  mounted() {
    this.getItems()
  },

  methods: {
    queryProcessor(query) {
      return {
        ...query,
        order: [ [ 'createdAt', orderDirections.DESC ] ]
      }
    },

    async getItems() {
      if (this.requestId) {
        try {
          this.state = states.loading
          const { data } = await Vue.$GRequest.get(apiPath, 'channel', { query: this.queryProcessor({ requestId: this.requestId }) })
          if (data?.data) {
            this.state = states.success
            this.items = data.data
          }
        } catch (error) {
          this.state = states.error
          globalErrorHandler.call(this, globalErrorProcessor.call(this, error))
        } finally {
          this.state = states.ready
        }
      }
    }
  },

  render
}
